import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {

  title: string = 'Nota legal:';
  description: string = 'El código fuente de cada componente presente en esta versión de la Biblioteca Digital de Componentes de integración (BDC) cumple con los requerimientos mínimos exigidos por la normativa vigente. Sin embargo, es responsabilidad de cada entidad, cuando integre estos componentes a sus soluciones digitales, el continuar garantizando el cumplimiento de los criterios de usabilidad, accesibilidad y funcionalidad de los mismos.';

  constructor() {
    //Empty Function
  }

  ngOnInit(): void {
    //Empty Function
  }
}